import { keyframes } from '@mui/material/styles';
import { MenRunningAnimation, RocketAnimation, BirdAnimation } from '@common/assets';

/**
 * Returns animation for progress bar (i.e  Men Running, Bird or Rocket) based on
 * Students progress for the week or day agains set personal goal or day/week goal
 */
export const getGoalIndicatorAnimation = ({
  completedLessons,
  goal,
  personalGoal,
}: {
  completedLessons: number;
  goal: number;
  personalGoal: number | null | undefined;
}) => {
  let animation: any = MenRunningAnimation;

  if (completedLessons >= goal) {
    animation = BirdAnimation;
  }

  // Check only if personal goal is set
  if (personalGoal) {
    // If personal goal is greater then goal and progress is greater then personal goal
    if (personalGoal >= goal && completedLessons >= personalGoal) {
      animation = RocketAnimation;
    }

    // If personal goal is less then goal and complted lesson is between personal and goal value
    if (personalGoal < goal && completedLessons >= personalGoal && completedLessons < goal) {
      animation = RocketAnimation;
    }
  }

  return animation;
};

export const getProgressBarAnimation = (progress: number) => keyframes`
  from {
    width: 0;
  }
  to {
    width: ${Math.max(0, Math.min(progress, 100)) ?? 0}%};
  }
`;
